export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/e0ab7379baf600f9962514af15119239.png";